// ...imports stay the same
import React, { useState } from "react"; 
import Classes from "./RecordTable.module.css";
import { useNavigate } from "react-router-dom";
import RateExperiencePopup from "../../../../../../GlobalComponents/RateExperiencePopup/RateExperiencePopup";
import backend from "../../../../../../../api";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import MoreDropDown from "./MoreDropDown";

export default function TableRow({ value, index }) {
  const navigateTo = useNavigate();
  const bookingId = value._id;
  const [showRatingPopup, setShowRatingPopup] = useState(false);

  // --- helpers: parse "YYYY-MM-DD at HH:mm" and format "MM/DD/YYYY at h:mm"
  const parseStartsInToDate = (s) => {
    if (!s) return null;
    const cleaned = String(s).trim(); // handle trailing newline
    const [datePart, timePart = "00:00"] = cleaned.split(" at ").map(x => x.trim());
    const [y, m, d] = (datePart || "").split("-").map(Number);
    const [hh, mm] = (timePart || "").split(":").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, (m || 1) - 1, d || 1, hh || 0, mm || 0);
  };

  const formatStartsInCompact12h = (s) => {
    const dt = parseStartsInToDate(s);
    if (!dt || isNaN(dt.getTime())) return (s?.trim?.() || "N/A");

    const pad2 = (n) => String(n).padStart(2, "0");
    const M = pad2(dt.getMonth() + 1);
    const D = pad2(dt.getDate());
    const Y = dt.getFullYear();

    const hours24 = dt.getHours();
    const h12 = (hours24 % 12) || 12;            // 0->12, 13->1, etc.
    const minutes = pad2(dt.getMinutes());

    return `${M}/${D}/${Y} at ${h12}:${minutes}`;
  };

  const formattedStartsIn = formatStartsInCompact12h(value.startsIn);

  const openProfile = () => navigateTo(value.profileUrl);

  const handleRateMeeting = () => setShowRatingPopup(true);
  const handleClosePopup = () => setShowRatingPopup(false);

  const handleSubmitRating = async (rating) => {
    try {
      await backend.put(`/bookings/${bookingId}`, { rating });
      setShowRatingPopup(false);
      window.location.reload();
    } catch (error) {
      console.error("Error submitting rating:", error);
    }
  };

  // rating button visibility (fixed precedence)
  const currentDateTime = new Date();
  const meetingDateTime = parseStartsInToDate(value.startsIn);
  const canRate =
    (meetingDateTime && meetingDateTime < currentDateTime) &&
    (value.rating === undefined || value.rating === null);

  return (
    <>
      <div className={`${Classes.customerRow}`} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}>
          <h5>{value.mentorName}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem2}`}>
          <h5>{value.type}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem3}`}>
          <h5 className={Classes.statusText}>{formattedStartsIn}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem4}`}>
          <div
            style={{
              background: value.status.label === "Accepted" ? "#008000" : "#F26A63",
            }}
            className={Classes.dot}
          ></div>
          <h5>{value.status.label}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem5}`}>
          {value.meetingLink ? (
            <a href={value.meetingLink} target="_blank" rel="noopener noreferrer">
              <h5>Click Here</h5>
            </a>
          ) : (
            <h5>N/A</h5>
          )}
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem6}`}>
          <h5 onClick={openProfile}>View</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem7}`}>
          {value.rating !== undefined && value.rating !== null ? (
            <h5> {value.rating}/5</h5>
          ) : canRate ? (
            <button
              onClick={handleRateMeeting}
              className={`${Classes.rateButton} ${Classes.coloredText}`}
            >
              Rate
            </button>
          ) : (
            <h5>N/A</h5>
          )}
        </div>
         <div className={`${Classes.rowElem} ${Classes.elem8}`}>
          <MoreDropDown booking={value} index={index}/>
        </div>
      </div>

      {/* mobile section unchanged except uses formattedStartsIn */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}>
            <h4>Name</h4>
            <h5>{value.mentorName}</h5>
          </div>
          <div className={Classes.mobElem}>
            <h4>Type</h4>
            <h5>{value.type}</h5>
          </div>
          <div className={Classes.mobElem}>
            <h4>Starts In</h4>
            <h5 className={Classes.statusText}>{formattedStartsIn}</h5>
          </div>
        </div>
        <div>
          <div className={Classes.mobElem}>
            <h4>Status</h4>
            <div className={Classes.flexAlign5}>
              <div
                style={{
                  background: value.status.label === "Accepted" ? "#008000" : "#F26A63",
                }}
                className={Classes.dot}
              ></div>
              <h5>{value.status.label}</h5>
            </div>
          </div>
          <div className={Classes.mobElem}>
            <h4>Meeting Link</h4>
            {value.meetingLink ? (
              <a href={value.meetingLink} target="_blank" rel="noopener noreferrer">
                <h5 className={Classes.coloredText}>Click Here</h5>
              </a>
            ) : (
              <h5 className={Classes.coloredText}>N/A</h5>
            )}
          </div>
          <div className={Classes.mobElem}>
            <h4>Profile</h4>
            <h5 onClick={openProfile} className={Classes.coloredText}>
              View
            </h5>
          </div>
          <div className={Classes.mobElem}>
            <h4>Rating</h4>
            {value.rating !== undefined && value.rating !== null ? (
              <h5> {value.rating}/5</h5>
            ) : canRate ? (
              <button
                onClick={handleRateMeeting}
                className={`${Classes.rateButton} ${Classes.coloredText}`}
              >
                Rate
              </button>
            ) : (
              <h5 className={Classes.coloredText}>N/A</h5>
            )}
          </div>
        </div>
      </div>

      {showRatingPopup && (
        <RateExperiencePopup
          handleClose={handleClosePopup}
          handleSubmit={handleSubmitRating}
        />
      )}
    </>
  );
}
